/// <reference path="../types/index.d.ts" />

import '../client_forms/mculinary4/style.css';
import FormStructure from './mculinary4/form_structure';

export default FormStructure;